import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {CreditCardEntryForm} from '@mintdata-wsp/wsp/ui/views/workspace/settings/billing/paymentMethod/CreditCardEntryForm';

const styles = require('./CreditCardEntryDialog.less');
const cx = classnames.bind(styles);

@observer
export class CreditCardEntryDialog extends React.Component<any, any>
{
    render()
    {
        return  <Dialog className={cx('creditCardEntryDialog')}>
                    <CreditCardEntryForm/>
                </Dialog>;
    }
}
